var $ca0549dfb1669363$exports = {};
$ca0549dfb1669363$exports = {
  "pending": `\u{10D}ek\xe1 na vy\u{159}\xedzen\xed`
};
export { $ca0549dfb1669363$exports as default };